import styled from 'styled-components';
import color from '../../../utils/colors.constants';

const Label = styled.label`
    color: ${color.AZUL};
    margin-left: 3px;
    font-weight: bold;
    font-size: 13px;
`;

export default Label;
